import { createRouter, createWebHistory } from 'vue-router';
import LandingPage from './views/LandingPage.vue';
import WebinarVideo from './views/WebinarVideo.vue';

const routes = [
    {
        path: '/',
        name: 'LandingPage',
        component: LandingPage,
    },
    {
        path: '/webinar',
        name: 'WebinarVideo',
        component: WebinarVideo,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;
